import { useTranslation } from "../../../../language";

export default function ChangePaymentText() {
  const { t } = useTranslation();
  return <span>{t("pay_subtext")}</span>;
}
